
export default {
    name: 'Hero',
}
